import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";

export default function LatestNewsFeed() {
  const items = newsList.slice(0, 5);

  return (
    <aside className="rounded-lg border border-background-200 bg-background-50 p-4 h-full flex flex-col">
      <div className="flex items-center justify-between pb-3 border-b border-background-100">
        <div className="flex items-center gap-2">
          <span className="relative w-2 h-2 rounded-full bg-accent-500">
            <span className="absolute inset-0 rounded-full bg-accent-500/50 animate-ping" />
          </span>
          <h2 className="text-base font-bold text-foreground-950 font-heading">最新影视资讯</h2>
        </div>
        <Link
          to="/category/news"
          className="text-xs text-primary-600 hover:text-accent-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          全部资讯
        </Link>
      </div>

      <ul className="flex-1 divide-y divide-background-100">
        {items.map((item) => (
          <li key={item.id}>
            <Link
              to={`/news/${item.id}`}
              className="group flex gap-3 py-3 first:pt-3.5 cursor-pointer"
            >
              <div className="w-[88px] h-[60px] rounded-md overflow-hidden shrink-0 bg-primary-900">
                <img
                  src={item.image}
                  alt={`${item.title}资讯配图`}
                  title={`${item.title} 影视资讯`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 text-[11px] text-foreground-400 font-label">
                  <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-900">
                    {item.category}
                  </span>
                  <span>{item.date}</span>
                </div>
                <h3 className="text-sm font-medium text-foreground-900 mt-1 leading-snug line-clamp-2 group-hover:text-accent-700 transition-colors">
                  {item.title}
                </h3>
                <p className="hidden sm:block text-xs text-foreground-500 mt-1 line-clamp-1">
                  {item.summary}
                </p>
              </div>
            </Link>
          </li>
        ))}
      </ul>

      <Link
        to="/category/news"
        className="mt-3 flex items-center justify-center gap-1 h-9 rounded-md bg-background-100 text-sm text-primary-700 hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap"
      >
        浏览更多资讯
        <i className="ri-arrow-right-line text-sm w-4 h-4 flex items-center justify-center" />
      </Link>
    </aside>
  );
}